import httpRequest from 'httpRequest'
import { VoidCompReasonContract } from 'models'

const VOID_COMP_REASON_SERVICE = '/company/void-comp-reason'

const voidCompReasonService = {
    getVoidCompReasons: () => {
        return httpRequest.get<VoidCompReasonContract[]>(
            VOID_COMP_REASON_SERVICE,
        )
    },
    getVoidCompReasonById: (id: string) => {
        return httpRequest.get<VoidCompReasonContract>(
            `${VOID_COMP_REASON_SERVICE}/${id}`,
        )
    },
    createVoidCompReason: (payload: VoidCompReasonContract) => {
        return httpRequest.post(`${VOID_COMP_REASON_SERVICE}`, payload)
    },
    updateVoidCompReason: (id: string, payload: VoidCompReasonContract) => {
        return httpRequest.put(`${VOID_COMP_REASON_SERVICE}/${id}`, payload)
    },
    deleteVoidCompReason: (voidIds: string[]) => {
        return httpRequest.delete(`${VOID_COMP_REASON_SERVICE}`, {
            params: { voidIds },
        })
    },
}

export default voidCompReasonService
